<template>
  <div class="message-recharge">
    <p class="module-item-title">请选择套餐</p>
    <ul class="msg-recharge-package-container">
      <li class="msg-recharge-package-item"
          :class="seletedIndex == i ? 'package-item-actived' : ''"
          v-for="(item, i) in packageList" @click="choosePackage(i)">
        <div class="package-name">
          <span>{{item.name}}</span>
        </div>
        <div class="package-detail-container">
          <div class="package-price">¥<span>{{item.amount}}</span></div>
          <div class="package-num">{{item.msgCount}}条</div>
        </div>
        <i v-if="seletedIndex == i ? true : false " class="selected-tc"></i>
      </li>
    </ul>
    <div class="to-recharge-container">
      <div>你即将充值 <span>¥<span class="recharge-price">{{selectedPackage.amount}}</span></span></div>
      <div class="wl-btn msg-recharge-btn" @click="toPay(selectedPackage.id)">立即充值</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'message-recharge',
    data() {
      return {
        seletedIndex:0,
        packageList:[],
        selectedPackage:{}
      }
    },
    created(){
      this.getRechargePackage()
    },
    mounted() {

    },
    methods: {
      /**
       * 获取套餐列表
       */
      getRechargePackage(){
        this.$http.msgRechargePackageAPI().then( res => {
          if(res.status == 1){
            this.packageList = res.data
            res.data.map( (item, i) => {
              if(i == this.seletedIndex){
                this.selectedPackage = item
              }
            })
          }
        })
      },
      /**
       * 选择套餐
       * @param index
       */
      choosePackage(index){
        this.seletedIndex = index
        this.packageList.map( (item, i) => {
          if(i == index){
            this.selectedPackage = item
          }
        })
      },
      toPay(id){
        this.$http.msgPayAPI({
          id
        }).then( res => {
          this.$confirm('即将跳转支付, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let div = document.createElement('div');
            div.innerHTML = res; // html code
            document.body.appendChild(div);
            document.forms['punchout_form'].submit();
          }).catch(() => {

          });

        })
      }
    }
  }
</script>

<style lang="scss">
.message-recharge{
  .msg-recharge-package-container{
    display: flex;
    flex-wrap: wrap;
    padding: 30px 0;
    .msg-recharge-package-item{
      display: flex;
      margin-right: 20px;
      margin-bottom: 20px;
      align-items: center;
      border: 1px solid #409eff;
      border-radius: $mainBorderRadius;
      height: 70px;
      cursor: pointer;
      position: relative;
      .selected-tc{
        display: inline-block;
        width: 72px;
        height: 72px;
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 99;
        background: url("~@/assets/images/selected.png") 100% 100% no-repeat;
      }
      .package-name{
        display: flex;
        width: 70px;
        height: 100%;
        align-items: center;
        justify-content: center;
        background-color: #409eff;
        color: #fff;
      }
      .package-detail-container{
        padding: 0 40px;
        text-align: center;
        width: 160px;
        .package-price{
          color: #333;
          span{
            font-size: 18px;
          }
        }
        .package-num{
          font-size: 12px;
          padding-top: 7px;
          color: #666;
        }
      }
      &.package-item-actived{
        border: 1px solid #fe8601;
        .package-name{
          background-color: #fe8601;
        }
        .package-price,.package-num{
          color: #fe8601;
        }
      }
    }
  }
  .to-recharge-container{
    display: flex;
    line-height: 40px;
    color: #333;
    font-size: 12px;
    span{
      color: #fe8601;
    }
    .recharge-price{
      font-size: 18px;
      font-weight: bold;
    }
    .msg-recharge-btn{
      background-color: #fe8601;
      margin-left: 20px;
    }
  }
}
</style>
